import { createMachine } from 'xstate';

export const cardCaptureMachine = createMachine({
  id: 'cardCaptureState',
  initial: 'idle',
  states: {
    idle: {
      on: {
        START: {
          target: 'cardNumber',
        },
      },
    },
    cardNumber: {
      on: {
        ALIGN_CAMERA: {
          target: 'alignCameraToFrame',
        },
      },
    },
    alignCameraToFrame: {
      on: {
        RESUME: [{ target: 'cardNumber' }],
      },
    },
  },
});
